<template>
  <cus-dialog-in-dialog>
    <template v-slot:body>
      <div class="body-wrap">
        <cus-button color="gray-noFocus" text="列印副本" @click="printCopy"></cus-button>
        <cus-button color="gray-noFocus" text="列印正本" @click="printOriginal"></cus-button>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="關閉" color="blue" @click="close"></cus-button>
      </div>
    </template>
  </cus-dialog-in-dialog>
</template>

<script>
import { inject, getCurrentInstance } from 'vue';
import { useActions } from '@/utils/mapStore';

export default {
  name: 'ReprintInvoice',
  setup() {
    const { proxy } = getCurrentInstance();

    // 接受provide值
    const close = inject('inner_close');
    const { cusProps } = inject('inner_cusProps');

    // 列印副本
    const doReprintInvoice = useActions('manageOrder', ['doReprintInvoice']);
    const printCopy = async () => {
      await doReprintInvoice({ order_id: cusProps.order_id });
    };

    // 列印正本
    const doReprintOriginalInvoice = useActions('manageOrder', ['doReprintOriginalInvoice']);
    const printOriginal = () => {
      proxy
        .$confirm({
          content: '正本發票重複列印可能產生重複兌獎及溢領中獎獎金的問題，是否仍要列印？',
          confirmText: '確認列印',
          confirm2Text: '取消',
          moreConfirm: true,
        })
        .then(async (val) => {
          if (val === '確認列印') {
            await doReprintOriginalInvoice({ order_id: cusProps.order_id });
          }
        })
        .catch((e) => e);
    };

    return {
      close,
      printCopy,
      printOriginal,
    };
  },
};
</script>

<style lang="scss" scoped>
.body-wrap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 120px);
  grid-gap: 8px;
  padding: 0 4px;
}
</style>
